import { render } from "./피부과.vue?vue&type=template&id=0a6d5728"
import script from "./피부과.vue?vue&type=script&lang=js"
export * from "./피부과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__